import { motion, Variants } from "framer-motion";
import { INFORMATIONS } from "../../data/constans";

type AnimationConfig = {
  initial?: object;
  animate?: object;
  transition?: object;
};

const Hero: React.FC = (): JSX.Element => {
  const container = (startingPosition: number, delay: number): Variants => ({
    initial: { x: startingPosition, opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.5, delay: delay } },
  });

  return (
    <div id="aboutme" className="mt-[8vh] scroll-mt-[8vh] bg-white">
      <div className="mx-auto w-[90%] py-8 md:min-h-[92vh] lg:w-[80%]">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <section className="order-2 flex flex-col items-center justify-center md:order-1 md:items-start md:pr-8">
            <motion.h1
              variants={container(-10, 0.5)}
              initial="initial"
              animate="animate"
              className="text-5xl font-extrabold text-blue-500 md:text-5xl lg:text-6xl xl:text-8xl"
            >
              {INFORMATIONS.name}
            </motion.h1>
            <motion.h2
              variants={container(-10, 1)}
              initial="initial"
              animate="animate"
              className="mt-4 text-xl font-semibold text-blue-500 md:text-xl lg:text-2xl xl:text-4xl"
            >
              {INFORMATIONS.jobName1}
            </motion.h2>
            <motion.h2
              variants={container(-10, 1)}
              initial="initial"
              animate="animate"
              className="text-xl font-semibold text-blue-500 md:text-xl lg:text-2xl xl:text-4xl"
            >
              {INFORMATIONS.jobName2}
            </motion.h2>
            <div className="mt-8 flex flex-col space-y-4 text-justify text-sm font-light text-blue-500 lg:text-base">
              <motion.p variants={container(-10, 1.5)} initial="initial" animate="animate">
                {INFORMATIONS.aboutMe1}
              </motion.p>
              <motion.p variants={container(-10, 2)} initial="initial" animate="animate">
                {INFORMATIONS.aboutMe2}
              </motion.p>
              <motion.p variants={container(-10, 2.5)} initial="initial" animate="animate">
                {INFORMATIONS.aboutMe3}
              </motion.p>
            </div>
          </section>
          <section className="order-1 flex items-center justify-center pb-8 md:order-2 lg:pb-0 lg:pl-8">
            <motion.img
              variants={container(10, 1)}
              initial="initial"
              animate="animate"
              className="rounded-3xl object-cover shadow-lg shadow-blue-500"
              src="/profile.jpg"
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export default Hero;
